<template>
  <div class="overflow-hidden">
    <div class="page-title text-center px-5 mt-8 mt-md-16">
      <h2 class="text-2xl font-weight-semibold text--primary d-flex align-center justify-center mb-4">
        <v-icon color="warning" class="mr-2">{{ icons.mdiAlert }}</v-icon>
        <span class="me-2">{{ $t('pageNotFound') }}</span>
      </h2>

      <v-btn depressed color="primary" to="/" class="mb-4">{{ $t('backHome') }}</v-btn>
    </div>
  </div>
</template>

<script>
import { mdiAlert } from '@mdi/js'

export default {
  setup() {
    return {
      icons: {
        mdiAlert,
      },
    }
  },
}
</script>
